
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { ReferenceFileInformation } from "../../../domain/document";
import { IContentSource } from "../../../domain/drawing";

@Component
export default class ReferenceFileViewMixin extends Mixins() {
  @Prop()
  getReferenceFile: (fileId: number | string) => Promise<IContentSource>;

  async getReferenceFileSource(fileId: number): Promise<IContentSource> {
    return this.getReferenceFile
      ? this.getReferenceFile(fileId)
      : DomainRegistry.document.getDocumentRepository().getReferenceFile(fileId);
  }

  openReferenceFileViewer(file: ReferenceFileInformation): void {
    const pdfExtensionRegEx = /\.pdf$/i;
    if (file.name && pdfExtensionRegEx.test(file.name)) {
      if (this.shouldShowReferencePdfFileByClientViewer) {
        this.launchPdfViewer(file);
      } else {
        this.openWindow(file);
      }
    } else {
      this.openFile(file);
    }
  }

  get shouldShowReferencePdfFileByClientViewer(): boolean {
    return this.$configuration.behavior.format.referenceFile.shouldShowPdfByClientViewer;
  }

  private launchPdfViewer(file: ReferenceFileInformation) {
    this.getReferenceFileSource(file.id)
    .then(source => {
      if (!source) { 
        this.$error("説明資料エラー", "説明資料を取得できませんでした。");
        return;
      }
      const service = DomainRegistry.localhost.getApplicationService();
      service.showPdfByClientViewer(source, file.name);
    });
  }

  private openWindow(file: ReferenceFileInformation) {
    this.getReferenceFileSource(file.id)
    .then(source => {
      if (!source) { 
        this.$error("説明資料エラー", "説明資料を取得できませんでした。");
        return;
      }
      const param: any = {
        name: file.name,
        encodedUri: encodeURIComponent(source.source),
        isPrintable: true.toString(),
        forceEnableOpenTypeFontFace: this.$configuration.behavior.format.referenceFile.forceEnableOpenTypeFontFace.toString(),
      };
      this.$openWindow("/ShowDocumentSimply", param);
    });
  }

  private openFile(file: ReferenceFileInformation): void {
    this.getReferenceFileSource(file.id)
    .then(source => {
      if (!source) { return; }
      this.$openWindow(source.source);
    });
  }

}
